import { FileQuestion } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <section className="content-wrap page-hero">
      <div className="empty-state">
        <FileQuestion size={42} aria-hidden="true" />
        <h1 style={{ margin: '1rem 0 .4rem' }}>404</h1>
        <p>{t('errors.generic')}</p>
        <Link className="button" style={{ marginBlockStart: '1rem' }} to="/">{t('navigation.home')}</Link>
      </div>
    </section>
  );
}
